import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const FloatingButton = () => {
  return (
    <a
      href="https://wa.me/919902806732" // ✅ Change to your number
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg z-50 
                 animate-pulse transition transform hover:scale-110"
    >
      <FaWhatsapp size={24} />
    </a>
  );
};

export default FloatingButton;
